import { dataHook, dataCompType } from '../../utils'

export const withRootTemplate = (
  body: string,
  hook: string,
  dataCompTypeId: string,
  classList: string,
) =>
  `<div class="${classList}" 
  ${dataHook(hook)} 
  ${dataCompType(dataCompTypeId)} 
  >${body}</div>`
